<template>
  <ClModal v-model="active" :blur="true" :persistent="true">
    <v-card rounded class="rounded-xl">
      <div class="course-modal">
        <img src="../../../assets/images/courses/DoreJameEbtedayi6ta91404-Small.png">
        <div class="col-two">
          <div class="course-modal-description p-4">
            <h3>کلاس‌های فارسی، ریاضی و علوم ویژه پایه‌‌های اول تا پنجم دبستان
            </h3>
            <p>شروع از 1 مهر 1403</p>
            <p>پایان دوره اردیبهشت 1404</p>
            <p>هفته اول رایگان برای همه</p>
          </div>
          <div class="btns-box">
            <a class="btn cl-btn cl-btn-blue "
               @click="gotoFilteredCourses('/courses?courses=454%2C451%2C448%2C445%2C442&grades=&lessons=&professors=')">نمایش
              دوره‌ها</a>
          </div>
        </div>
      </div>
    </v-card>
  </ClModal>
</template>

<script>
import ClModal from "@/components/common/ClModal.vue";

export default {
  name: "DoreJameDahom1404",
  components: {ClModal},
  props: ['activeCourse'],
  data() {
    return {
      active: false
    }
  },
  mounted() {
    this.active = true
  },
  methods: {
    gotoFilteredCourses(params) {
      this.$router.push(params)
    },
    close() {
      this.active = false;
    }
  },
  watch: {
    activeCourse() {
      this.active = true
    }
  }

}
</script>

<style scoped>
</style>
